export default {
  title: 'Genveje',
  links: {
    reservations: 'Reservationer',
    orders_portal: 'Terminal-login',
    closed: 'Lukket?',
    menu: 'Skift menu',
    payouts: 'Udbetalingsrapporter',
    opening_hours: 'Åbningstider',
  },
};
